export default __webpack_public_path__ + "static/icon-5-6-28e869d841e36e325f5df5319778cc42.png";